import type { ReactNode } from 'react';

export const symbol_format_image_break_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-315v-330q0-12.75 8.63-21.38Q467.25-675 480-675h330q12.75 0 21.38 8.62Q840-657.75 840-645v330q0 12.75-8.62 21.37Q822.75-285 810-285H480q-12.75 0-21.37-8.63Q450-302.25 450-315Zm60-30h270v-270H510v270Zm135-135ZM150-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm0-660q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Z"
		/>
	</svg>
);
